import audio from 'services/api/audio'
import blog from 'services/api/blog'
import categories from 'services/api/categories'
import characters from 'services/api/characters'
import contactUs from 'services/api/contactUs'
import dictionary from 'services/api/dictionary'
import documents from 'services/api/documents'
import galleries from 'services/api/galleries'
import gameContent from 'services/api/gameContent'
import images from 'services/api/images'
import immersionLabels from 'services/api/immersionLabels'
import joinRequests from 'services/api/joinRequests'
import languages from 'services/api/languages'
import memberships from 'services/api/memberships'
import mySites from 'services/api/mySites'
import pages from 'services/api/pages'
import partsOfSpeech from 'services/api/partsOfSpeech'
import people from 'services/api/people'
import search from 'services/api/search'
import sites from 'services/api/sites'
import songs from 'services/api/songs'
import stats from 'services/api/stats'
import stories from 'services/api/stories'
import storyPages from 'services/api/storyPages'
import videos from 'services/api/videos'
import vimeoThumbnail from 'services/api/videoLinkThumbnails'
import visibility from 'services/api/visibility'
import widgets from 'services/api/widgets'
import wordOfTheDay from 'services/api/wordOfTheDay'

export default {
  audio,
  blog,
  categories,
  characters,
  contactUs,
  dictionary,
  documents,
  galleries,
  gameContent,
  images,
  immersionLabels,
  joinRequests,
  languages,
  memberships,
  mySites,
  pages,
  partsOfSpeech,
  people,
  search,
  sites,
  songs,
  stats,
  stories,
  storyPages,
  videos,
  vimeoThumbnail,
  visibility,
  widgets,
  wordOfTheDay,
}
